import Hero from './hero';
import AppAbout from './about';
import AppFeature from './feature';
import AppFAQ from './faq';

function AppHome() {
  return (
    <div className=''>
      <Hero />
      <AppAbout />
      <AppFeature />
      <AppFAQ />
    </div>
  );
}

export default AppHome;